import { render, staticRenderFns } from "./TwoColumnsTableData.vue?vue&type=template&id=b5c66ccc&scoped=true"
import script from "./TwoColumnsTableData.vue?vue&type=script&lang=js"
export * from "./TwoColumnsTableData.vue?vue&type=script&lang=js"
import style0 from "./TwoColumnsTableData.vue?vue&type=style&index=0&id=b5c66ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c66ccc",
  null
  
)

export default component.exports